import { Courthouse, Courtroom } from '../../read';
export function mapLocationToCourtroom(location) {
    const courthouse = (location === null || location === void 0 ? void 0 : location.parent)
        ? new Courthouse(location.parent.id, location.parent.name, location.parent.courtSystemId, undefined, location.parent.timeZoneId || undefined)
        : undefined;
    return location
        ? new Courtroom(location.id, location.name, location.courtSystemId, location.isArchived, courthouse)
        : undefined;
}
